<template>
  <h2 class="heading">
    <slot />
  </h2>
</template>

<style lang="scss" scoped>
.heading {
  font-size: 16px;
  font-weight: 300;
  line-height: 28px;
  letter-spacing: 2px;

  @apply md:text-[20px] md:leading-[30px];
}
</style>
